import { ll } from "../../core/ll";
import K_FlyUpInput from "../templates/K_FlyUpInput";
import { Component, ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface FlyUpInputOptions extends ComponentOptions {
    components?: Component[];
    bsc?: string;
    title?: string;
    placeholder?: string;
    imageClass?: string;
    required?: boolean;
    name?: string;
    inputType?: string;
    autoFocus?: string;
}

export class FlyUpInput extends TemplateComponent {

    options: FlyUpInputOptions;
    content: {
        components: Component[];
    };

    constructor(options: FlyUpInputOptions) {
        super(K_FlyUpInput, options);

        this.content = {
            components: options.components || []
        };
    }

    preRender() {
        const options = this.options;

        options.title = options.placeholder || "";
        options.imageClass = options.imageClass || "";
        options.placeholder = ll(options.placeholder, true) || "";
        options.name = options.name || "";
        options.inputType = options.inputType || "text";
        options.autoFocus = options.autoFocus || "";
    }

    create() {

        // Special events for placeholder inputs for UserName and Password
        $("#" + this.options.id).parents(".fly-up-input").bind("click", function (ev) {
            var elem = $(ev.currentTarget);
            elem.find(".fly-up-placeholder").focus();
        });
        $("#" + this.options.id).bind("keyup change focus focusout", function (ev) {
            var elem = this;
            var length = $(elem).val().length;
            var parent = $(elem).parents(".fly-up-input-container");
            var label = parent.find(".fly-up-label");
            var flyUpInput = $(elem).parents(".fly-up-input");

            if (navigator.userAgent.match(/msie/i) || !!window.MSStream) {
                label.animate({
                    "line-height": "8px",
                    "opacity": 1
                });
                $(".fly-up-input .fly-up-placeholder").removeAttr("placeholder");
                // Every other browser
            } else {
                if (length > 0) {
                    if (!label.is(":animated") || label.css("line-height") != "12px") {
                        label.animate({
                            "line-height": "8px",
                            "opacity": 1
                        });
                    }
                } else {
                    label.stop().animate({
                        "line-height": "20px",
                        "opacity": 0
                    });
                }
            }

            if (ev.type == "focus" || ev.type == "focusin") {
                flyUpInput.addClass("focus");
            } else if (ev.type == "focusout") {
                flyUpInput.removeClass("focus");
            }
        });

    }

}
